import React from "react";
import { ReactComponent as SearchIcon } from "../../../../../assets/images/companyIcons/search.svg";
import { ReactComponent as SearchNotFound } from "../../../../../assets/images/searchResultsNotFound.svg";

export const EmptySearch = ({ searchEmptyText }) => {
  return (
    <div className="flex flex-col items-center justify-center p-4 gap-4">
      {searchEmptyText === "Search & Select your company" || searchEmptyText === "Search & Select your Insurer" || searchEmptyText === "Search & Select your Broker" ? <SearchIcon /> : <SearchNotFound/>}
      <span>{searchEmptyText}</span>
    </div>
  );
};
